export default __webpack_public_path__ + "static/media/ic_success.4881df6f.svg";